import React, { useEffect, useMemo } from 'react';
import ReactGA from "react-ga4";
import { BASE_PATH } from '../..';
import { AssetSearchResultDTO } from '../../openapi/requests';
import Overlay from '../layout/Overlay';
import './AssetDetails.scss';

interface Props {
    open: boolean;
    asset?: AssetSearchResultDTO;
    onClose: () => void;
}

const WorkflowAssetDetails: React.FC<Props> = ({ open, asset, onClose }) => {

    const metadata = useMemo(() => {
        var data = [...asset?.metadata ?? []];

        return data.sort((a, b) => {
            let comp = a.name.localeCompare(b.name, 'en', { sensitivity: 'base' });

            if (comp === 0) {
                comp = a.value.localeCompare(b.value, 'en', { sensitivity: 'base' });
            }
            return comp
        })
    }, [asset?.metadata]);

    useEffect(() => {
        if (open) {
            ReactGA.event('open_dialog', { dialog: 'workflowassetdetails' });
        }
    }, [open]);

    return (
        <>
            <Overlay open={open} onClose={onClose} className='asset-details'>
                <div className="asset-detail-header"><h1>{asset?.title}</h1></div>
                <div className="asset-details-overlay-content">
                    <div className='meta info-list'>
                        <div className="info-list-header"><span>Details</span></div>
                        <ul>
                            {asset?.link && <li key="workflowlink"><span><a target='_blank' rel="noreferrer" href={asset.link}>Open in workflow</a></span><span></span></li>}
                            {metadata.map(e => <li key={e.name + e.value}><span>{e.name}</span><span>{e.value}</span></li>)}
                        </ul>
                    </div>
                    <div className='images info-list'>
                        <div className="info-list-header"><span>Asset</span></div>
                        {asset && <img src={BASE_PATH + asset.thumbnail} alt={asset.title} />}
                    </div>
                </div>
            </Overlay>
        </>
    );
};

export default WorkflowAssetDetails;